import moment from 'moment';
import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { OrderDate } from 'src/constrains/AdvancedFilters/Components';
import { EPolicy } from 'src/constrains/AdvancedFilters/Components/CommonDate';
import { ESearchCondition } from 'src/constrains/AdvancedFilters/Components/OrderDate';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
const Item = Form.Item;
const format = (d) => {
  return moment(d).format('YYYY-MM-DD');
};

const _OrderDate = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    rootName,
    form,
    noStyle,
    selectName,
    daysName,
    policyName,
    singleDayName,
    dayRangeName,
    defaultState,
    ...rest
  } = props;
  const handleOnReset = () => {
    form.setFieldsValue(defaultState);
  };
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(rootName);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const type = getFieldValue(selectName);
        const handleOnClose = () => {
          form
            .validateFields([policyName, daysName, singleDayName, dayRangeName])
            .then(() => {
              //console.log('没错');
            })
            .catch((r) => {
              handleOnReset();
            });
        };
        const hasData = !!type;
        const selectDic = {
          [ESearchCondition.HAVE_PLACED_ANY_ORDER]: getI18n(
            'customerList.orderDate.haveplacedorders',
          ),
          [ESearchCondition.HAVE_NOT_PLACED_ANY_ORDER]: getI18n(
            'customerList.orderDate.havenotplacedanyorder',
          ),
        };

        const prefix = selectDic[type];
        const textGenerator = () => {
          if (hasData) {
            const policy = getFieldValue(policyName);

            if (policy === EPolicy.AFTER_DATE) {
              const value = getFieldValue(singleDayName);
              return replaceI18nVariables(
                getI18n(`customerList.registeredSpecificTime.after`),
                prefix,
                format(value),
              );
            }
            if (policy === EPolicy.ANY_TIME) {
              return replaceI18nVariables(
                getI18n(`customerList.registeredSpecificTime.period`),
                prefix,
              );
            }
            if (policy === EPolicy.IN_BETWEEN) {
              const [from, to] = getFieldValue(dayRangeName) || [];
              return replaceI18nVariables(
                getI18n(`customerList.registeredSpecificTime.between`),
                prefix,
                format(from),
                format(to),
              );
            }
            if (policy === EPolicy.BEFORE_DATE) {
              const value = getFieldValue(singleDayName);
              return replaceI18nVariables(
                getI18n(`customerList.registeredSpecificTime.before`),
                prefix,
                format(value),
              );
            }

            if (policy === EPolicy.LAST_SPECIFIC_DAYS) {
              const value = getFieldValue(daysName);
              return replaceI18nVariables(
                getI18n(`customerList.registeredSpecificTime.within`),
                prefix,
                value,
              );
            }
            if (policy === EPolicy.ON_DATE) {
              const value = getFieldValue(singleDayName);
              return replaceI18nVariables(
                getI18n(`customerList.registeredSpecificTime.on`),
                prefix,
                format(value),
              );
            }
          }
          return '';
        };

        return (
          <Co
            header={
              <div>{getI18n('customerList.advancedFilter.orderdate')}</div>
            }
            displayText={textGenerator()}
            hasData={hasData}
            onClose={handleOnClose}
            onClear={handleOnReset}>
            <OrderDate
              noStyle={noStyle}
              selectName={selectName}
              policyName={policyName}
              daysName={daysName}
              singleDayName={singleDayName}
              dayRangeName={dayRangeName}
              {...rest}
            />
          </Co>
        );
      }}
    </Item>
  );
};
export default _OrderDate;
